import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { isMobileScreen } from '@/Utils';
import { TOGGLE_FOCUS_MODE_COMMAND } from '@standardnotes/ui-services';
import Icon from '@/Components/Icon/Icon'; // Add this import
const FocusModeSwitch = ({ application, onToggle, isEnabled }) => {
    const toggle = useCallback(() => {
        onToggle(!isEnabled);
    }, [onToggle, isEnabled]);
    const shortcut = useMemo(() => application.keyboardService.keyboardShortcutForCommand(TOGGLE_FOCUS_MODE_COMMAND), [application]);
    const isMobile = application.isNativeMobileWeb() || isMobileScreen();
    if (isMobile) {
        return null;
    }
    return (_jsxs("button", { onClick: toggle, className: "flex items-center px-2 py-1 text-sm hover:bg-neutral-10", title: `Focus Mode ${shortcut ? `(${shortcut})` : ''}`, children: [_jsx(Icon, { type: isEnabled ? 'eye-off' : 'eye', className: "mr-2" }), "Focus Mode"] }));
};
export default FocusModeSwitch;
